import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { daySpec, dayStatus, type DaySpec, type DayStatus } from './schema'

const Nothing = () => null

/** Days have no rows of their own: the morning brief and the recap show them. */
export const dayKind: ClientKind<DaySpec, DayStatus> = {
  name: 'Day',
  version: 1,
  spec: daySpec,
  status: dayStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: [],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: false,
}

export * from './schema'
export type { DayResource } from './apply'
